

  export default {
    props: {
      modalName: {
        type: String,
      },
      modalTitle: {
        type: String,
      },
      modalSize: {
        type: String
      }
    },
    data(){
      return {
        copiedUrl: false,
        url: '/',
      };
    },
    mounted() {
      this.url = window.location.href;
    },
     destroyed() {
      document.body.classList.remove('modalOverflow')
      if(document.getElementById('closeModal'))
      document.getElementById('closeModal').click();
    },
    methods: {
      closeModal() {
        // Emit this information to the parents component
         this.copiedUrl = false;
        this.$emit("child-modal", true);
      },
      copyLink(){
        var Url = this.$refs.mylink;
        Url.select();
        document.execCommand("copy");
      }
    }
  }

